import "./Summary.css";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

const scrollTo = (id, offset = 80) => {
  if (id === "home") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }
};

export default function Summary() {
  const handleGetInTouch = () => {
    scrollTo("contact", 80);
  };

  return (
    <>
      <div className="summary-container" id="summary">
        <h1>
          <span>About</span> Me
        </h1>
        <div className="summary-parent">
          <div className="summary-side">
            <div className="side-els">
              <div className="summary-icon">
                <PeopleAltOutlinedIcon />
              </div>
              <div>
                <h6 className="custom-h6">
                  Turning Ideas into Digital Reality
                </h6>
                <p
                  style={{
                    margin: "0",
                  }}>
                  Hi, I'm Ahmed Khaled, a junior Front-End Developer passionate
                  <br />
                  about Building responsive, user-friendly web applications.
                  <br /> I specialize in React.js, TypeScript, Redux Toolkit,
                  and Tailwind CSS
                  <br /> to create modern, reality through clean, efficient
                  code, With strong continuous
                  <br /> learning and teamwork, I'm ready to contribute to
                  real-world projects
                  <br /> either remotely or on-site (based in Giza, Egypt)
                </p>
              </div>
            </div>
          </div>
          <div className="summary-cv">
            <div className="summary-btns-cv">
              <button
                className="summary-btn touch-btn"
                onClick={handleGetInTouch}>
                Get in touch
              </button>

              <a
                href="Ahmed_Khaled.pdf"
                download="Ahmed_Khaled.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
                className="summary-btn cv-btn">
                Download CV
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
